






import { Component, Vue } from 'vue-property-decorator';
import device from '@/store/modules/device';
import redirectToLocation from '@/commons/redirectManager';

@Component({
    components: {},
})
export default class Logo extends Vue {
    private mounted() {
        device.updateMobileDetection();
    }

    private created() {
        device.detectMobile();
    }

    private redirectToHome() {
        redirectToLocation('/');
    }
}
